/**
 * Filtre par famille de la grille de la page Collection.
 *
 * Un seul role : montrer ou masquer des groupes deja rendus. Il ne selectionne
 * aucune variante, n'appelle pas la Section Rendering API et ne touche pas a
 * l'URL — cette page est de la navigation, pas de la configuration, et rien de
 * ce qui s'y passe n'a d'etat a transmettre.
 *
 * La barre de filtre est rendue avec `hidden` et c'est ce composant qui la
 * revele. Sans JS il n'y aurait rien a quoi se rabattre — Liquid ne lit aucun
 * parametre d'URL, donc pas de filtrage cote serveur — et des boutons inertes
 * seraient pires qu'absents. La grille reste alors complete et entierement
 * parcourable : c'est le repli, et il suffit.
 */
class GoGridFilter extends HTMLElement {
  connectedCallback() {
    this.bar = this.querySelector('[data-grid-filter-bar]');
    this.buttons = Array.from(this.querySelectorAll('[data-grid-filter]'));
    this.groups = Array.from(this.querySelectorAll('[data-grid-family]'));
    if (!this.bar || this.buttons.length === 0) return;

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);

    this.bar.hidden = false;
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-grid-filter]');
    if (!button || !this.buttons.includes(button)) return;

    this.apply(button.dataset.gridFilter);
  }

  /** Chaine vide = toutes les familles. C'est la valeur du bouton « Toutes »,
   *  donc un seul chemin pour les deux cas au lieu d'un drapeau a part. */
  apply(family) {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.gridFilter === family ? 'true' : 'false');
    });

    this.groups.forEach((group) => {
      group.hidden = family !== '' && group.dataset.gridFamily !== family;
    });
  }
}

// Meme garde que les autres composants GO! : deux balises <script src>
// identiques sur une page s'executent deux fois, et le second passage
// redefinirait un nom deja pris.
if (!customElements.get('go-grid-filter')) {
  customElements.define('go-grid-filter', GoGridFilter);
}
